export const LOGIN_OPTION = {
  FACE: "face",
  CODE: "code",
};
